import { Styles } from "react-select";
import { ReactSelectDropdownOption } from "../types";
import { colors } from "../styles/variables";
import { ThemeInterface } from "../theme/theme";
import {
  INPUT_HEIGHT,
  INPUT_BORDER_RADIUS,
} from "../components/fields/base.styled";

export const getThemedSelectStyles = (
  theme?: ThemeInterface,
  valid?: boolean,
  invalid?: boolean,
  focused?: boolean
): Partial<Styles<ReactSelectDropdownOption, false>> => {
  const getBorderColor = () => {
    if (invalid) return colors.red;
    if (valid) return colors.green;
    if (theme && focused) return theme.color.primary;
    return colors.gray300;
  };

  return {
    clearIndicator: () => ({ visibility: "hidden" }),
    container: (provided) => ({
      ...provided,
      minWidth: "64px",
    }),
    control: (provided) => ({
      ...provided,
      alignItems: "flex-start",
      borderRadius: INPUT_BORDER_RADIUS,
      boxShadow: "none",
      backgroundColor: "transparent",
      cursor: "pointer",
      minHeight: 0,
      height: INPUT_HEIGHT,
      border: `1px solid ${getBorderColor()}`, // @mixin form-element-border
      "&:hover": {
        borderColor: getBorderColor(),
      },
      "&:focused": {
        borderColor: theme ? theme.color.primary : colors.gray300,
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      path: {
        fill: invalid ? colors.red : colors.gray600,
      },
    }),
    indicatorSeparator: () => ({ visibility: "hidden" }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 220,
    }),
    option: (provided, { isSelected, isFocused }) => ({
      ...provided,
      cursor: "pointer",
      fontSize: "16px",
      backgroundColor: isSelected
        ? colors.gray300
        : isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "transparent",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "100%",
      fontSize: "16px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
    }),
  };
};
